import { AccomodationFirstChildren } from "@models/accomodation-first-children.model";
import { BaseConverter } from "./BaseConverter";
import { AccomodationFirstChildrenDto } from "@dtos/accomodation-first-children.dto";
import { CardInfoTranslationConverter } from "./cardInfoTranslationConverter";
import { AccomodationTranslationConverter } from "./accomodationTranslationConverter";

export class AccomodationFirstChildrenConverter extends BaseConverter<AccomodationFirstChildren, AccomodationFirstChildrenDto>{
    private accomodationConverter = new AccomodationTranslationConverter()
    private childrenConverter = new CardInfoTranslationConverter()
    modelToDto(model: AccomodationFirstChildren): AccomodationFirstChildrenDto {
        return new AccomodationFirstChildrenDto(
            model.accomodation ? this.accomodationConverter.modelToDto(model.accomodation) : undefined ,
            model.otherActiveAccomodation,
            model.children ? this.childrenConverter.modelsToDtos(model.children) : undefined
        )
    }
    dtoToModel(dto: AccomodationFirstChildrenDto): AccomodationFirstChildren {
        return new AccomodationFirstChildren(
            dto.accomodation ? this.accomodationConverter.dtoToModel(dto.accomodation) : undefined,
            dto.otherActiveAccomodation,
            dto.children ? this.childrenConverter.dtosToModels(dto.children) : undefined
        )
    }
}